<template>
  <div class="profile-main container">
    <MainLayout>
      <div class="previousBtn">
        <el-button
          @click="goToPreviousPage()"
          type="text"
          icon="el-icon-arrow-left"
          class="button my-account-btn"
        >
          {{ $t("common.previousPageBtn.myAccount") }}
        </el-button>
      </div>
      <el-row class="d-flex align-items-center">
        <el-col class="p-20 sales-image sales-img-sec" :xs="24" :sm="12" :md="12">
          <div class="bg-accent-light text-center p-20 mt-15">
            <img :src="salesImage" class="account-image" />
          </div>
        </el-col>
        <el-col class="p-20" :xs="24" :sm="12" :md="12">
          <h1 class="text-left history-title text-left d-flex align-items-center" v-html="title"></h1>
        </el-col>
      </el-row>
      <el-row class="">
        <LayoutSection size="v100" class="text-left">
          <div class="select-order">
            <span class="order-place pr-15"
              ><b>{{ ordersPlacedIn }}</b></span
            >
            <el-select
              v-model="selectedYear"
              @change="yearFilter"
              class="history-years mt-5"
              :no-data-text="this.$i18n.t('users.account.salesHistory.noData')"
              :placeholder="this.$i18n.t('users.account.salesHistory.noData')"
            >
              <el-option
                v-for="item in years"
                :key="item"
                :label="item"
                :value="item"
              />
            </el-select>
          </div>
          <el-table
            ref="sales"
            :data="salesOrders"
            :stripe="false"
            :show-header="false"
            style="width: 100%"
            :emptyText="emptyTableOrderText"
            @row-click="handleExpand"
          >
            <el-table-column prop="date">
              <template slot-scope="props">
                <div>{{ orderHeader }}</div>
                {{ formatDate(props.row.date) }}
              </template>
            </el-table-column>
            <el-table-column prop="name">
              <template slot-scope="props">
                <div>{{ saleOrderNumberHeader }}</div>
                {{ props.row.soNumber }}
              </template>
            </el-table-column>
            <el-table-column prop="total">
              <template slot-scope="props">
                <div>{{ totalHeader }}</div>
                {{ formatPrice(props.row.total) }}
              </template>
            </el-table-column>
            <el-table-column type="expand">
              <template slot-scope="props">
                <el-link
                  v-for="invoice in props.row.invoices"
                  :key="invoice.id"
                  @click="downloadInvoice(invoice.id, props.row.soNumber)"
                >
                  <i v-if="invoice" class="portaus-icon-download">
                    <span class="invoice-btn mr-1">
                      {{ $t("users.account.salesHistory.invoice") }}</span
                    >
                  </i>
                </el-link>
                <div class="mt-20">
                  <el-row>
                    <h4>Produits de l'agence</h4>
                  </el-row>
                  <el-row v-for="line in props.row.lines" :key="line.id">
                    <SalesProductLine
                      :sales-product-line="line"
                      :product="getproduct(line.puid)"
                    />
                  </el-row>
                </div>
              </template>
            </el-table-column>
            <el-table-column> </el-table-column>
            <el-table-column> </el-table-column>
          </el-table>
        </LayoutSection>
      </el-row>
    </MainLayout>
  </div>
</template>

<script>
import dayjs from "dayjs";

import { map, sortedUniq, find } from "@/utils/lodash";
import { formatCurrency } from "@/utils/common-utils";
import daysjsUtils from "@/utils/dayjs-utils";

import userApi from "@/api/user";

import LayoutSection from "@/components/layout/layout-section.vue";

import SalesProductLine from "./components/product-sales-line.vue";
import { filter } from "@/utils/lodash";

import { mapState, mapActions } from "vuex";

// import productApi from "@/api/product";

import MainLayout from "@/components/layout/main-layout.vue";

export default {
  components: {
    LayoutSection,
    SalesProductLine,
    MainLayout
  },
  props: {},
  data() {
    return {
      salesOrders: [],
      selectedYear: null,
      allOrder: [],
      productData: [],
    };
  },
  computed: {
    ...mapState("shoppingCart", ["shoppingCart"]),
    orderHeader() {
      return this.$i18n
        .t("users.account.salesHistory.orderHeader")
        .toUpperCase();
    },
    saleOrderNumberHeader() {
      return this.$i18n
        .t("users.account.salesHistory.salesOrderNumberHeader")
        .toUpperCase();
    },
    totalHeader() {
      return this.$i18n
        .t("users.account.salesHistory.salesOrderTotalHeader")
        .toUpperCase();
    },
    ordersPlacedIn() {
      return this.$i18n.t("users.account.ordersPlacedIn");
    },
    emptyTableOrderText() {
      return this.$i18n.t("users.account.emptyOrderTableText");
    },
    years() {
      const years = map(this.allOrder, (so) => dayjs(so.date).year());
      if (years.length > 0) {
        return sortedUniq(years);
      }
      return [];
    },
    title() {
      return this.$i18n.t("users.account.salesHistoricTitle").toUpperCase();
    },
    salesImage() {
      /* eslint-disable global-require */
      return require("@/assets/images/account/sales-historic.png");
    },
    ...mapState("user", ["user"]),
  },
  methods: {
    ...mapActions("shoppingCart", ["fetchShoppingCart"]),
    downloadInvoice(invoiceId, filename) {
      return userApi.downloadInvoice(invoiceId, filename);
    },
    handleExpand(row) {
      this.$refs.sales.toggleRowExpansion(row);
    },
    formatDate(date) {
      return daysjsUtils(date, "LL");
    },
    formatPrice(price) {
      return formatCurrency(price, this.$i18n.locale);
    },
    goToPreviousPage() {
      this.$router.go(-1);
    },
    yearFilter() {
      this.salesOrders = filter(
        this.allOrder,
        (p) => new Date(p.date).getFullYear() == this.selectedYear
      );
    },
    setProductsData(salesOrders) {
      let product = [];
      salesOrders.forEach((value) => {
        value.lines.forEach((pro) => {
          if (product.some((e) => e == pro.puid)) return;
          this.singleProducData(pro.product);
          product.push(pro);
        });
      });
    },
    singleProducData(data) {
      this.productData.push(data);
      // productApi.getSingleProduct(id, idType).then((data) => {
      //   this.productData.push(data);
      // });
    },
    getproduct(puid) {
      const product = find(this.productData, (p) => {return p.puid === puid});
      return product;
    },
  },
  async mounted() {
    const getId = JSON.parse(localStorage.getItem("user"));
    await this.fetchShoppingCart({
        id: getId.id,
        idType: "id",
      })
    const customerId = this.shoppingCart.account && this.shoppingCart.account.customer.id;
    if (!customerId) {
      return;
    }
    
    // const currentYear = new Date().getFullYear();
    userApi.listSalesOrders(customerId).then((salesOrders) => {
      this.setProductsData(salesOrders);
      this.allOrder = salesOrders;
      var currentYear = new Date().getFullYear();
      this.salesOrders = filter(
        salesOrders,
        (p) => new Date(p.date).getFullYear() == currentYear
      );
      if (this.years.length > 0) {
        [this.selectedYear] = this.years;
      }
    });
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/variables.scss";
.previousBtn {
  font-family: "Futura Std ", "Futura Std", sans-serif;
  font-weight: 500;
  color: $color-primary;
  text-align: left;
  line-height: normal;
  letter-spacing: 1.25px;
  font-size: 16px !important;
}

.el-table__expanded-cell[class*="cell"] {
  padding-left: 2px;
  padding-right: 2px;
  padding-top: 20px;
  padding-bottom: 20px;
}

.invoice-btn {
  color: $color-primary !important;
}
.previousBtn {
  .el-button--text {
    color: #a31c25;
    cursor: pointer;
    font-weight: 500 !important;
  }
  .previousBtn {
    color: $color-primary;
    cursor: pointer;
    padding-bottom: 20px;
  }
  .el-button:hover {
    text-decoration: underline;
  }
}
.order-place {
  font-size: 18px;
  font-weight: 600;
}

.history-title {
  font-size: 48px;
}
.el-select {
  border: 2px solid #606266;
}
.history-years .el-input__inner {
  font-size: 18px !important;
  width: 90px !important;
}

.el-select-dropdown__empty {
  padding: 1rem !important;
}

.history-years .el-input__suffix {
  top: 3px;
}
.select-order {
  margin-top: 40px;
}
.my-account-btn {
  padding-left: 0 !important;
}
.sales-img-sec {
  padding-left: 0px;
}
.text-left.d-flex{
  height: 100%;
}
.d-flex.align-items-center.el-row {
  flex-wrap: wrap;
}
@media (min-width: 999px) {
  .account-image {
    width: 351px;
    height: 263px;
  }
}
</style>
